import { Component, OnInit, Input, AfterViewInit, HostListener, Renderer2, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Animation } from 'src/app/interfaces/animation.interface';
import { socialFade } from 'src/app/animations/animation';
import { AnimationService } from 'src/app/services/animation.service';
import { PageService } from 'src/app/services/page.service';
import { DomSanitizer } from '@angular/platform-browser';
import Player from '@vimeo/player';
import { RelatedOverlayComponent } from '../../modules/related-overlay/related-overlay.component';
import { Related } from 'src/app/interfaces/related.interface';
import { RelatedService } from 'src/app/services/related.service';
import { of } from 'rxjs';
@Component({
    selector: 'app-work',
    templateUrl: './work.component.html',
    styleUrls: ['./work.component.scss'],
    animations: [socialFade]
})
export class WorkComponent implements OnInit, AfterViewInit {
    @Input() work;
    @Input() i: number;
    @Input() type: string;
    @Input() key: number;
    @Input() counter: number;
    @Input() postsize;
    iframeIsLoaded: boolean = false;
    imageIsLoaded: boolean = false;
    videourl: any;
    videoOnHoverUrl: any;
    player: Player;
    hoverPlayer: Player;
    dangerousUrl: any;
    dangerousHoverUrl: any;
    animation: Animation[] = [];
    activeDtlPostButton: number = null;
    activeQckPostButton: number = null;
    activeSecond: number;
    activeFirst: number;
    activePostItem: number;
    activeItem: number;
    activeLoader = false;
    textLoaderRightH1 = false;
    textLoaderRightH3 = false;
    textLoaderRightBtn = false;
    textLoaderLeftH1 = false;
    textLoaderLeftH3 = false;
    textLoaderLeftBtn = false;
    screenWidth: number = 0;
    screenHeight: number = 0;
    imagePathArray;
    bannerItem: any;
    slug: string;
    activateId: number;
    workActive: number;
    imageItem: number;
    width: number;
    dotswidth: number = 0;
    left: number;
    top: number;
    height: number;
    elementTop: number;
    elementTopQuickView: number;
    returncolorvalue: any;
    postLoaded: boolean = false;
    backgroundchecked: boolean = false;
    showPost: boolean = false;
    transitionactive: boolean = false;
    videoprogress: number = 0;
    labelwidth: number = 0;
    seekbarproggress: number = 0;
    secondprogress: number = 0;
    minuteprogress: number = 0;
    totalminuteduration: number = 0;
    totalsecondduration: number = 0;
    progresstime: number = 0;
    durationTimer: boolean = false;
    startVideo: boolean = false;
    hiddeButton: boolean = false;
    ispaused: boolean = true;
    isplaying: boolean = false;
    resetTransition: boolean = false;
    relatedOverlay: Related[] = [];
    preloader_color: string;
    quickViewActive: boolean = false;
    main = document.getElementsByClassName('main')[0];
    is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    fadeclass: string = '';
    displayItemSafari: boolean = false;
    workHoverInSlide: boolean = false;
    workHoverInVideo: boolean = false;
    interval: any;
    sliderInterval: any;
    activeSliderImage: number = 0;
    galleryIsLoaded: boolean = false;
    activeSlide: number = 0;
    isTouchDevice = /iPhone|iPad|iPod|Android|webOS|BlackBerry|Opera Mini|IEMobile/i.test(navigator.userAgent);
    isIPadPro = /Macintosh/.test(navigator.userAgent) && 'ontouchend' in document;
    viewPortActive: boolean = false;
    activateMenuOverlay: boolean = false;
    hoveredAboveSlider: boolean = false;
    videoOnHoverDiv = document.getElementById("videoIframe");
    @ViewChild('videoplayer') videoplayer: ElementRef;
    @ViewChild('hoverVideoplayer') hoverVideoplayer: ElementRef;
    @ViewChild('workdiv', { static: true }) workdiv: ElementRef;
    @ViewChild('postactive', { static: true }) postactive: ElementRef;
    @ViewChild('playeroverlay', { static: true }) playeroverlay: ElementRef;
    @ViewChild('quickcontent', { static: true }) quickcontent: ElementRef;
    @Output() animationData: EventEmitter<any> = new EventEmitter<any>();
    @Output() animationDataReset: EventEmitter<any> = new EventEmitter<any>();
    @Output() relatedData: EventEmitter<any> = new EventEmitter<any>();
    @Output() relatedDataQuickView: EventEmitter<any> = new EventEmitter<any>();
    @Output() quickViewData: EventEmitter<any> = new EventEmitter<any>();
    @Output() emitScroll: EventEmitter<any> = new EventEmitter<any>();
    @Output() emitOverlayRelated: EventEmitter<any> = new EventEmitter<any>();

    public animationParams = {
        top: null,
        left: null,
        right: null,
        bottom: null,
        width: null,
        height: null,
        active: null,
    }

    public quickAnimationParams = {
        top: null,
        left: null,
        right: null,
        bottom: null,
        width: null,
        height: null,
        active: null,
    }

    public quickViewRelated = {
        slug: null,
        index: null,
        imagepath: null
    }

    constructor(private animationService: AnimationService,
        private sanitizer: DomSanitizer,
        private related: RelatedService,
        private pageService: PageService) {
        this.animationService.returnAnimationIndex().subscribe((data) => {
            if (this.work.slug === data.slug) {
                this.imageItem = data.index;
                this.bannerItem = this.imagePathArray[data.index];
            }
        });
        this.pageService.activateMenuOverlayListen().subscribe((resp) => {
            this.activateMenuOverlay = resp;
        })
        this.onResize(event);
    }

    @HostListener('window:resize', ['$event'])
    onResize(event?) {
        this.screenWidth = window.innerWidth;
        this.screenHeight = document.getElementById('main-container-wrapper').clientHeight;
    }

    ngOnInit() {
        this.imagePathArray = this.work.acf.project_modules[0].banner_gallery;
        this.imageItem = Math.floor(Math.random() * this.imagePathArray.length);
        this.activeSlide = this.imageItem;
        this.labelwidth = 150 / this.work.acf.project_modules[0].banner_gallery.length;
        this.getRouteParams();
        this.preloader_color = this.getRandomColor();

        // if (this.work.acf.project_modules[0].work_page_video) {
        //     this.dangerousHoverUrl = 'https://player.vimeo.com/video/' + this.work.acf.project_modules[0].work_page_video + '?autoplay=0&loop=1&autopause=0&background=1&byline=0&portrait=0&muted=1';
        //     this.videoOnHoverUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.dangerousHoverUrl);
        //     setTimeout(() => {
        //         this.hoverPlayer = new Player(this.hoverVideoplayer.nativeElement);
        //         setTimeout(() => {
        //             this.hoverPlayer.play();
        //             setTimeout(() => {
        //                 this.hoverPlayer.pause();
        //                 this.hoverPlayer.setCurrentTime(0);
        //             }, 1000);
        //         }, 1000);
        //     }, 600);
        // }
    }

    playHoverVideo() {
        if (this.hoverPlayer) {
            this.hoverPlayer.play();
        }
        if (this.work.acf.project_modules[0].work_page_video) {
            setTimeout(() => {
                this.workHoverInVideo = true;
            }, 0);
        } else {
            setTimeout(() => {
                this.workHoverInSlide = true;
                if(this.sliderInterval){
                    clearInterval(this.sliderInterval);
                }
                this.setSliderInterval()
            }, 0);
        }
    }

    pauseHoverVideo() {
        if (this.hoverPlayer) {
            this.hoverPlayer.pause();
            this.hoverPlayer.setCurrentTime(0);
        }

        if (this.work.acf.project_modules[0].work_page_video) {
            setTimeout(() => {
                this.workHoverInVideo = false;
            }, 0);
        } else {
            setTimeout(() => {
                this.workHoverInSlide = false;
                if(this.sliderInterval){
                    clearInterval(this.sliderInterval);
                }
            }, 0);
        }
    }

    setSliderInterval(){
        this.sliderInterval = setInterval(() => {
            
            if (this.activeSliderImage > this.work.acf.project_modules[0].banner_gallery.length - 2) {
                this.activeSliderImage = 0;
            } else {
                this.activeSliderImage++;
            }
            console.log(this.activeSliderImage);

        }, 1500);
    }

    getRandomColor() {
        const hue = 0;
        const saturation = 0;
        const brightness = this.getRandomNumber(85, 95);
        return 'hsl(' + hue + ', ' + saturation + '%, ' + brightness + '%)';
    }

    getRandomNumber(low, high) {
        var r = Math.floor(Math.random() * (high - low + 1)) + low;
        return r;
    }

    ngAfterViewInit() {
        if (this.workdiv.nativeElement.getBoundingClientRect().left >= this.screenWidth / 2) {
            setTimeout(() => {
                this.fadeclass = 'fade-right';
            }, 0);
        } else {
            setTimeout(() => {
                this.fadeclass = 'fade-left';
            }, 0);
        }
    }

    getRouteParams() {
        if (window.location.pathname.split('/')[1] == 'works') {
            this.slug = this.work.slug;
        } else {
            this.slug = 'work/' + this.work.slug;
        }
    }

    loadedImage() {
        this.showPost = true;
    }

    public onIntersection({ target, visible }: { target: Element; visible: boolean }): void {
        if (visible) {
            this.viewPortActive = true;
        }
        if (visible && !this.bannerItem) {
            this.bannerItem = this.imagePathArray[this.imageItem];
        }
    }

    public itemActive(event): void {
        this.resetTransition = true;
        let element;
        if (event.target.nodeName == 'H3' || event.target.nodeName == 'H5') {
            element = event.target.offsetParent.offsetParent.offsetParent.offsetParent;
        } else if (event.target.nodeName == 'BUTTON') {
            element = event.target.offsetParent.offsetParent.offsetParent.offsetParent.offsetParent;
        } else {
            element = event.target.offsetParent.offsetParent;
        }
        let offsetTop = element.offsetTop;
        this.animationParams.width = element.offsetWidth;
        this.animationParams.height = element.offsetHeight;
        this.animationParams.left = element.offsetLeft;
        if (this.screenWidth > 767) {
            this.animationParams.top = offsetTop;
        } else {
            this.animationParams.top = offsetTop + this.screenHeight;
        }
        this.animationParams.bottom = (offsetTop + element.offsetHeight);
        this.animationParams.right = element.offsetLeft + element.offsetWidth;

        this.animationParams.active = this.i;
        this.animationService.animateImageIndex(this.imageItem);
        this.animationData.emit(this.animationParams);
        setTimeout(() => {
            this.resetTransition = false;
        }, 500);
        this.pageService.worksLoaded();
    }

    showQuickView(event) {
        if (this.is_safari) {
            this.displayItemSafari = true;
        }
        this.resetTransition = true;
        this.quickViewActive = true;

        let element = event.target.offsetParent.offsetParent.offsetParent;

        let top = element.offsetTop;
        let left = element.offsetLeft;
        let width = element.offsetWidth;
        let height = element.offsetHeight;
        let bottom = top + height;
        let right = width + left;

        this.quickAnimationParams.top = top;
        this.quickAnimationParams.left = left;
        this.quickAnimationParams.right = right;
        this.quickAnimationParams.bottom = bottom;
        this.quickAnimationParams.width = width;
        this.quickAnimationParams.height = height;
        this.quickAnimationParams.active = this.i;
        if (!this.is_safari) {
            this.postactive.nativeElement.style.width = (width - 10) + 'px';
            this.postactive.nativeElement.style.height = (height - 10) + 'px';
            this.postactive.nativeElement.style.left = (left + 5) + 'px';
            this.postactive.nativeElement.style.right = (right + 5) + 'px';
            this.postactive.nativeElement.style.top = (top + 5) + 'px';
            this.postactive.nativeElement.style.bottom = (bottom + 5) + 'px';
        } else {
            this.postactive.nativeElement.style.width = (width - 10) + 'px';
            this.postactive.nativeElement.style.height = (height - 10) + 'px';
            this.postactive.nativeElement.style.left = (left - 5) + 'px';
            this.postactive.nativeElement.style.right = (right - 5) + 'px';
            this.postactive.nativeElement.style.top = (top + 5) + 'px';
            this.postactive.nativeElement.style.bottom = (bottom + 5) + 'px';
        }

        this.postactive.nativeElement.style.position = 'fixed';
        this.postactive.nativeElement.style.zIndex = '9999';

        let elemWidth = (1 - 0.3) * this.screenWidth;
        let elemHeight = (1 - 0.3) * this.screenHeight;
        this.elementTopQuickView = -this.counter + (this.screenHeight - elemHeight) / 2 - 40;
        let elemLeft = (this.screenWidth - elemWidth) / 2;
        this.emitScroll.emit('pause');
        setTimeout(() => {
            this.transitionactive = true;
            this.postactive.nativeElement.style.position = 'fixed';
            this.postactive.nativeElement.style.width = elemWidth + 'px';
            this.postactive.nativeElement.style.height = elemHeight + 'px';
            this.postactive.nativeElement.style.left = (elemLeft - 10) + 'px';
            this.postactive.nativeElement.style.top = this.elementTopQuickView + 'px';
            this.playeroverlay.nativeElement.classList.add('active');
            this.playeroverlay.nativeElement.style.top = -this.counter + 'px';
            const fadeclasess = document.getElementsByClassName('fade-overlay-quickview');
            for (let index = 0; index < fadeclasess.length; index++) {
                const fadeclass = fadeclasess[index];
                fadeclass.classList.add('active');
            }
            this.quickcontent.nativeElement.style.top = (this.elementTopQuickView + elemHeight + 20) + 'px';
            this.quickcontent.nativeElement.style.left = (elemLeft - 10) + 'px';
            this.quickcontent.nativeElement.style.zIndex = '9999';
        }, 100);
        const videoid = this.work.acf.project_modules[0].banner_video;
        if (videoid) {
            setTimeout(() => {
                this.callEventVideo(videoid);
            }, 500);
        } else {
            this.callEventGallery();
        }
    }

    callEventGallery() {
        this.galleryIsLoaded = true;
        this.interval = setInterval(() => {
            if (this.dotswidth >= 100) {
                this.dotswidth = 0;
                if (this.activeSlide > this.work.acf.project_modules[0].banner_gallery.length - 2) {
                    this.activeSlide = 0;
                } else {
                    this.activeSlide++;
                }
            } else {
                this.dotswidth++;
            }
            this.bannerItem = this.imagePathArray[this.activeSlide];
        }, 150);
    }

    nextSlide() {
        this.dotswidth = 0;
        if (this.activeSlide > this.work.acf.project_modules[0].banner_gallery.length - 2) {
            this.activeSlide = 0;
        } else {
            this.activeSlide++;
        }
        this.bannerItem = this.imagePathArray[this.activeSlide];
    }

    prevSlide() {
        this.dotswidth = 0;
        if (this.activeSlide < 0) {
            this.activeSlide = this.work.acf.project_modules[0].banner_gallery.length - 2;
        } else {
            this.activeSlide--;
        }
        this.bannerItem = this.imagePathArray[this.activeSlide];
    }

    activeQuivkViewSlide(i) {
        this.dotswidth = 0;
        this.activeSlide = i;
        this.bannerItem = this.imagePathArray[this.activeSlide];
    }

    callEventVideo(videoid) {
        this.dangerousUrl = 'https://player.vimeo.com/video/' + videoid + '?autoplay=0&loop=1&autopause=0&background=1&byline=0&portrait=0&muted=1';
        this.videourl = this.sanitizer.bypassSecurityTrustResourceUrl(this.dangerousUrl);
        setTimeout(() => {
            this.player = new Player(this.videoplayer.nativeElement);
            this.player.play();
            this.startVideo = true;
            this.player.on('timeupdate', function (data) {
                this.videoprogress = (data.percent * 100);
                this.minuteprogress = Math.floor(data.seconds / 60);
                this.minuteprogress = ('0' + this.minuteprogress).slice(-2);
                this.secondprogress = Math.floor(data.seconds) - this.minuteprogress * 60;
                this.secondprogress = ('0' + this.secondprogress).slice(-2);
                this.totalminuteduration = Math.floor(data.duration / 60);
                this.totalminuteduration = ('0' + this.totalminuteduration).slice(-2);
                this.totalsecondduration = Math.floor(data.duration) - this.totalminuteduration * 60;
                this.totalsecondduration = ('0' + this.totalsecondduration).slice(-2);
                this.seekbarproggress = (data.seconds / data.duration) * 100;
                this.progresstime = Math.floor(data.duration);
            });
        }, 300);
    }

    iframeLoaded() {
        this.iframeIsLoaded = true;
    }

    imageLoaded() {
        this.imageIsLoaded = true;
    }

    callPostFromQuickView() {
        this.iframeIsLoaded = false;
        this.imageIsLoaded = false;
        this.galleryIsLoaded = false;
        clearTimeout(this.interval);
        this.videourl = '';
        this.player = null;
        this.pageService.worksLoaded();
        let elemWidth = (1 - 0.3) * this.screenWidth;
        let elemHeight = (1 - 0.3) * this.screenHeight;
        let elemTop = this.elementTopQuickView;
        let elemLeft = (this.screenWidth - elemWidth) / 2;

        this.animationParams.width = elemWidth;
        this.animationParams.height = elemHeight;
        this.animationParams.left = elemLeft;
        this.animationParams.top = elemTop;
        this.animationParams.bottom = (elemTop + elemHeight);
        this.animationParams.right = elemLeft + elemWidth;

        this.animationParams.active = this.i;

        this.animationData.emit(this.animationParams);
        this.postactive.nativeElement.style.width = '';
        this.postactive.nativeElement.style.height = '';
        this.postactive.nativeElement.style.left = '';
        this.postactive.nativeElement.style.right = '';
        this.postactive.nativeElement.style.top = '';
        this.postactive.nativeElement.style.bottom = '';
        this.postactive.nativeElement.style.position = '';
        this.postactive.nativeElement.style.zIndex = '';

        this.animationService.animateImageIndex(this.imageItem);
        const fadeclasess = document.getElementsByClassName('fade-overlay-quickview');
        for (let index = 0; index < fadeclasess.length; index++) {
            const fadeclass = fadeclasess[index];
            fadeclass.classList.remove('active');
        }
        setTimeout(() => {
            this.transitionactive = false;
            this.playeroverlay.nativeElement.classList.remove('active');
            this.playeroverlay.nativeElement.style.top = '';
            this.animationDataReset.emit(this.quickAnimationParams);
            this.emitScroll.emit('start');
            this.resetTransition = false;
            if (this.is_safari) {
                this.displayItemSafari = false;
            }
        }, 900);
        this.quickViewActive = false;
    }

    onMouseMove($event) {
        if (this.startVideo == true) {
            var j;
            this.hiddeButton = true;
            clearTimeout(j)
            j = setTimeout(() => {
                this.hiddeButton = false;
            }, 4500);
        }
    }

    seekOutside(event) {
        const width = (1 - 0.3) * this.screenWidth;
        var pct = Math.floor((event.offsetX / width) * 100);
        let timeVal = (pct * this.player.progresstime) / 100;
        this.player.setCurrentTime(timeVal);
        this.player.play();
        this.player.clickPlay = false;
        this.player.clickPause = true;
        this.player.clickReplay = true;
    }

    removeQuickView() {
        this.iframeIsLoaded = false;
        this.galleryIsLoaded = false;
        this.imageIsLoaded = false;
        clearTimeout(this.interval);
        this.emitScroll.emit('start');
        this.videourl = '';
        this.player = null;
        const fadeclasess = document.getElementsByClassName('fade-overlay-quickview');
        for (let index = 0; index < fadeclasess.length; index++) {
            const fadeclass = fadeclasess[index];
            fadeclass.classList.remove('active');
        }
        this.playeroverlay.nativeElement.classList.remove('active');
        this.playeroverlay.nativeElement.classList.remove('active-related');
        this.playeroverlay.nativeElement.style.top = '';
        if (!this.is_safari) {
            this.postactive.nativeElement.style.width = (this.quickAnimationParams.width - 20) + 'px';
            this.postactive.nativeElement.style.height = (this.quickAnimationParams.height - 20) + 'px';
            this.postactive.nativeElement.style.left = (this.quickAnimationParams.left + 10) + 'px';
            this.postactive.nativeElement.style.right = (this.quickAnimationParams.right - 10) + 'px';
            this.postactive.nativeElement.style.top = (this.quickAnimationParams.top + 10) + 'px';
            this.postactive.nativeElement.style.bottom = (this.quickAnimationParams.bottom - 10) + 'px';
        } else {
            this.postactive.nativeElement.style.width = (this.quickAnimationParams.width - 20) + 'px';
            this.postactive.nativeElement.style.height = (this.quickAnimationParams.height - 20) + 'px';
            this.postactive.nativeElement.style.left = (this.quickAnimationParams.left) + 'px';
            this.postactive.nativeElement.style.right = (this.quickAnimationParams.right) + 'px';
            this.postactive.nativeElement.style.top = (this.quickAnimationParams.top + 10) + 'px';
            this.postactive.nativeElement.style.bottom = (this.quickAnimationParams.bottom + 10) + 'px';
        }
        setTimeout(() => {
            if (this.is_safari) {
                this.displayItemSafari = false;
            }
            this.postactive.nativeElement.style.width = '';
            this.postactive.nativeElement.style.height = '';
            this.postactive.nativeElement.style.left = '';
            this.postactive.nativeElement.style.right = '';
            this.postactive.nativeElement.style.top = '';
            this.postactive.nativeElement.style.bottom = '';
            this.postactive.nativeElement.style.position = '';
            this.postactive.nativeElement.style.zIndex = '';
            if (this.is_safari) {
                this.postactive.nativeElement.style.display = 'none';
                setTimeout(() => {
                    this.postactive.nativeElement.style.display = 'block';
                }, 3);
            }
            this.transitionactive = false;
            this.resetTransition = false;
        }, 700);
        this.quickViewActive = false;
    }
}
